import { Icon, IconProps } from "./Icon";

export function IconRightChevronBold(props: IconProps) {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M7 1.34 8.44 0 19 11.97 8.44 23.99 7 22.65 16.39 12 7 1.34Z"
      />
    </Icon>
  );
}
